var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"close"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("g",{"id":"Group_361","data-name":"Group 361"},[React.createElement("line",{"id":"Line_21","data-name":"Line 21","x1":"1","y1":"15.85","x2":"15.85","y2":"1","style":{"fill":"none","stroke":"#fff","strokeLinecap":"round","strokeWidth":"2px"},"key":0}),React.createElement("line",{"id":"Line_22","data-name":"Line 22","x1":"15.85","y1":"15.85","x2":"1","y2":"1","style":{"fill":"none","stroke":"#fff","strokeLinecap":"round","strokeWidth":"2px"},"key":1})])))]);
}

Close.defaultProps = {"viewBox":"0 0 16.85 16.85"};

module.exports = Close;

Close.default = Close;
